module.exports = __webpack_public_path__ + "media/zero-suit-samus.68b0a7bf.wav";